<xemex-dialog-shell [title]="'firmware.deactivateDialog.title' | translate">
  <div class="p-2">
    <span>{{ 'firmware.deactivateDialog.message' | translate }}</span>
    <div class="mt-3 p-3 bg-neutral-light rounded">
      <p>
        <strong>{{ 'firmware.deactivateDialog.version' | translate }}:</strong> {{ data.version }}
      </p>
      <p>
        <strong>{{ 'firmware.deactivateDialog.filename' | translate }}:</strong> {{ data.filename }}
      </p>
    </div>
  </div>
  <mat-dialog-actions actions>
    <xemex-filled-button (click)="onConfirm()" intent="destructive">
      {{ 'firmware.deactivateDialog.deactivate' | translate }}
    </xemex-filled-button>
    <xemex-outlined-button mat-dialog-close type="button">
      {{ 'general.btnCancel' | translate }}
    </xemex-outlined-button>
  </mat-dialog-actions>
</xemex-dialog-shell>
